export default defineNuxtRouteMiddleware((to) => {
  // Close auth modal if user is not going to signin or signup page
  const authenticationType = useAuthenticationType()
  const authenticationModalShown = useAuthenticationModal()

  if (authenticationType.value && to.name !== 'index-signin' && to.name !== 'index-signup') {
    authenticationModalShown.value = false
    authenticationType.value = null
  }
})
